import { FC } from 'react';
import { MapFallbackBoundary } from '../../HybridMap';
import CoverageMapMapbox from './CoverageMapMapbox';
import CoverageMapGoogle from './CoverageMapGoogle';

interface CoverageMapProps {
    pin?: { lng: number; lat: number } | null;
    flyTo?: { lng: number; lat: number } | null;
    onFlyToComplete?: () => void;
}

const CoverageMap: FC<CoverageMapProps> = ({ pin, flyTo, onFlyToComplete }) => (
    <MapFallbackBoundary
        persistKey="fleets-coverage"
        renderMapbox={({ reportLoaded, mapboxErrorHandler }) => (
            <CoverageMapMapbox
                pin={pin}
                flyTo={flyTo}
                onFlyToComplete={onFlyToComplete}
                onLoaded={reportLoaded}
                mapboxErrorHandler={mapboxErrorHandler}
            />
        )}
        renderGoogle={({ reportError }) => (
            <CoverageMapGoogle
                pin={pin}
                flyTo={flyTo}
                onFlyToComplete={onFlyToComplete}
                onLoadError={() => reportError('google-load-error')}
            />
        )}
    />
);

export { CoverageMap };
